import { PINTEREST_BUTTON } from '../classnames/blog';

export default class PinterestButton {
  pinterestButton = document.querySelector(`.${PINTEREST_BUTTON}`);

  loadPinterestScript = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = '//assets.pinterest.com/js/pinit.js';
    const firstScript = document.querySelector('script');
    firstScript.parentNode.insertBefore(script, firstScript);
  };

  handleClick = () => {
    window.PinUtils.pinAny();
  };

  initializeEventListeners = () => {
    this.pinterestButton.addEventListener('click', this.handleClick);
  };

  initialize = () => {
    if (this.pinterestButton) {
      this.loadPinterestScript();
      this.initializeEventListeners();
    }
  };
}
